import { initializeApp, } from 'firebase/app';
import { defineNuxtPlugin, useRuntimeConfig, } from 'nuxt/app';
import { getMessaging, } from 'firebase/messaging';

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig();
  console.log('firebase plugin config', config);

  const app = initializeApp(config.public.firebase.config);

  const messaging = getMessaging(app);

  nuxtApp.vueApp.provide('messaging', messaging);
  nuxtApp.provide('messaging', messaging);
});
